import { View } from 'react-native';
import { Head } from '@shared/components/head';
import { Text } from '@shared/components/text';
import { Button } from '@md-design-system/Button/Button';
import Icon from '@md-design-system/Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

export interface IMeasurementErrorStateProps {
  onRetry: () => void;
  onGoBack?: () => void;
  goBackText?: string;
}

export const MeasurementErrorState = ({
  onRetry,
  onGoBack,
  goBackText = 'measurement.goHome',
}: IMeasurementErrorStateProps) => {
  const { t } = dynamicTranslations();

  return (
    <View className="flex-1 flex-col justify-between py-6">
      <View className="flex-1 flex-col items-center justify-center gap-6">
        <View
          className="w-[120px] h-[120px] rounded-full justify-center items-center"
          style={{ backgroundColor: colorPalette.orange[100] }}
        >
          <Icon name="warning" size={56} color={colorPalette.warning[700]} />
        </View>
        <View className="gap-4">
          <Head type="h2" className="text-center">
            {t('measurement.deviceError.title')}
          </Head>
          <Text className="text-center font-base">
            {t('measurement.deviceError.description')}
          </Text>
        </View>
      </View>

      <View className="pt-6 gap-2">
        <Button variant="primary" size="large" icon="reload" onPress={onRetry}>
          {t('measurement.deviceError.retry')}
        </Button>
        {onGoBack && (
          <View className="items-center">
            <Button variant="link" icon="arrow-left" onPress={onGoBack}>
              {t(goBackText)}
            </Button>
          </View>
        )}
      </View>
    </View>
  );
};

export default MeasurementErrorState;
